// FILE: src/features/myActivitySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import fetchWithAuth from "../utils/fetchWithAuth";

// Thunk: fetch the current user's activity logs (Audit Logs) by userId
export const fetchMyActivity = createAsyncThunk(
  "myActivity/fetchMyActivity",
  async ({ userId, page, limit }, { rejectWithValue }) => {
    try {
      // Example: GET /api/audit-logs/6412abcd1234efgh?page=2&limit=5
      const url = `/api/audit-logs/${userId}?page=${page}&limit=${limit}`;
      const data = await fetchWithAuth(url);
      return data; // Should contain { logs, totalCount, currentPage, totalPages }
    } catch (err) {
      return rejectWithValue(err.message || "Failed to fetch user activity");
    }
  }
);

const myActivitySlice = createSlice({
  name: "myActivity",
  initialState: {
    logs: [],
    totalCount: 0,
    totalPages: 0,
    limit: 5, // default page size
    loading: false,
    error: null
  },
  reducers: {
    setLimit(state, action) {
      state.limit = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyActivity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload.logs;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchMyActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch user activity";
      });
  }
});

export const { setLimit } = myActivitySlice.actions;
export default myActivitySlice.reducer;
